import { TextareaDesignTokens } from '@primeuix/themes/types/textarea';

export const textarea: TextareaDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        borderColor: '{content.borderColor}',
      },
    },
  },
};
